// extracted by mini-css-extract-plugin
export default {"root":"IconCheckbox_root__6Li1m","input":"IconCheckbox_input__2LzOP","icon":"IconCheckbox_icon__5zYCe"};